module.exports = __webpack_public_path__ + "img/NL549.adb01480.png";